"use client";

import { Slot } from "radix-ui";
import { Fragment, type ReactNode } from "react";
import {
	Dialog,
	type DialogProps,
	SideDialog,
	type SideDialogProps,
	useDialogContext,
	useModal,
} from "../../..";

interface DialogButtonProps extends Omit<DialogProps, "open" | "onOpenChange"> {
	content: ReactNode;
}

export function DialogButton(props: DialogButtonProps) {
	const { children, content, ...remainingProps } = props;
	const dialog = useModal();

	return (
		<Fragment>
			<Slot.Root
				onClick={(e) => {
					e.stopPropagation();

					dialog.toggle();
				}}
			>
				{children}
			</Slot.Root>

			<Dialog {...dialog.props} {...remainingProps}>
				{content}
			</Dialog>
		</Fragment>
	);
}

interface SideDialogButtonProps extends Omit<SideDialogProps, "open" | "onOpenChange"> {
	content: ReactNode;
}

export function SideDialogButton(props: SideDialogButtonProps) {
	const { children, content, ...remainingProps } = props;
	const dialog = useModal();

	return (
		<Fragment>
			<Slot.Root
				onClick={(e) => {
					e.stopPropagation();

					dialog.toggle();
				}}
			>
				{children}
			</Slot.Root>

			<SideDialog {...dialog.props} {...remainingProps}>
				{content}
			</SideDialog>
		</Fragment>
	);
}

export function CloseDialogSlotWithScroll(props: { id: string; children: ReactNode }) {
	const { id, children } = props;

	const dialog = useDialogContext();
	const modal = useModal();

	return (
		<Slot.Root
			onClick={(e) => {
				e.stopPropagation();

				if (dialog) dialog.onOpenChange?.(false);
				modal.close();

				document.getElementById(id)?.scrollIntoView();
			}}
		>
			{children}
		</Slot.Root>
	);
}
